import React, {Component} from 'react';
import {connect} from 'react-redux';
import {RootState, selectors} from '../store';
import {
  IonPopover,
  IonIcon,
  IonSelect,
  IonSelectOption,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonMenuButton,
  IonBackButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonDatetime,
  IonCard,
  IonRow,
  IonCol,
  IonInput,
  IonCardHeader,
  IonCardContent,
  IonCardTitle,
  IonCardSubtitle,
  IonTitle
} from '@ionic/react';
import './Studentmanagement.css';
import {RouteComponentProps} from "react-router";
import {AuthComponent} from "./_/AuthComponent";
import _ from "../_";
import {ApiService} from "../_/ApiService";
import {Static} from "../_/Static";
import {StaticEvent} from "../_/StaticEvent";
import Moment from 'react-moment';
import {calendar, pin} from 'ionicons/icons';

type Props = RouteComponentProps<{}> & ReturnType<typeof mapStateToProps>

type State = {
  showPopover: boolean,
  showPopoverEvent: null | MouseEvent

  pageData?: any,
  _userData?: any,

  email?: any,
  password?: any,
  passwordagain?: any,
}

class SetPassword extends AuthComponent<Props, State> {
  static RoutePathname = /^\/setpassword/gi;

  constructor(props: Props) {
    super(props);

    this.state = {
      showPopover: false,
      showPopoverEvent: null,

      pageData: null,
    };
  }

  presentPopover = (e: MouseEvent) => {
    this.setState(() => ({
      showPopover: true,
      showPopoverEvent: e
    }));
  }

  async componentDidMount() {
    await super.componentDidMount();

    //必須要引用 AuthComponent, 才能在這裡拿取用戶資料
    //若是引用 BaseComponent 則不需要下面
    // @ts-ignore
    this.setState({
      _userData: this._userData,
    });
  }

  async afterEventsLoader() {
    window.setTimeout(() => {
      const myPathname = this.props.location.pathname;
      if (myPathname.match(SetPassword.RoutePathname)) {
        if (this._doLoadingPageDataInDidMount) {
          this._doLoadingPageDataInDidMount = false;
          this._loadPageData();
        } else {
          return;
        }
      }
    }, 1);
  }

  dismissPopover = () => {
    this.setState(() => ({
      'showPopover': false,
      'showPopoverEvent': null
    }));
  }

  async createAccount(e: any) {
    e.preventDefault();
    e.stopPropagation();


    // @ts-ignore
    const {email, password} = this.state;

    // @ts-ignore
    //const {dispatch} = this.props;
    //dispatch(userActions.login(username, password));

    if (email && password) {
      // WAITING SCREEN
      StaticEvent.LoadingEvent.next(true);

      // POST
      let postData = {
        email: email,
        password: password,
      };
      const postUrl = ApiService.urlMapping('~/api/1/_createaccount');
      Static.apiService
        .post(postUrl, postData)
        .subscribe(async (res) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);

            let data = res.data;
            _.debugManager.log(data);

            let error = data.error || null;
            let result = error == null;

            if (result) { // SUCEESS
              alert('申請成功');

              // @ts-ignore
              this.props.history.push('/')

              //window.location = '/f1';
              //history.pushState({}, 'page 2', '/f1');
              //await _.sharedStateManager.rootNav.setRoot(askMeIndex, {});
              //await this.viewCtrl.dismiss();

            } else {
              alert(error.message);
              // const controller: any = document.querySelector('ion-toast-controller');
              // let msg = await controller.create({
              //   message: error.message,
              //   duration: 2000,
              //   position: 'top'
              // });
              // await msg.present();
            }
          }, async (err) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);
            _.debugManager.warn(err);
            alert('網路連線有問題');
          }
        );
    }
  }

  handleInputChange(e) {
    if (e.target.name == 'password') {
      // @ts-ignore
      this.state.password = e.target.value;
    }
    if (e.target.name == 'passwordagain') {
      // @ts-ignore
      this.state.passwordagain = e.target.value;
    }
    if (this.state.password === this.state.passwordagain) {
      document.getElementById('markCheck').classList.add("checkpass");
    } else {
      document.getElementById('markCheck').classList.remove("checkpass");
    }

    // @ts-ignore
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  async _loadPageData() {
    // WAITING SCREEN
    StaticEvent.LoadingEvent.next(true);

    // POST
    let postData = {};
    const postUrl = ApiService.urlMapping('~/api/1/createaccount');
    Static.apiService
      .post(postUrl, postData)
      .subscribe(async (res: any) => {
          // CLOSE WAITING SCREEN
          StaticEvent.LoadingEvent.next(false);

          let data = res.data;
          _.debugManager.log(data);

          let error = data.error || null;
          let result = error == null;

          if (result) { // SUCEESS

            let payload = data.payload;
            _.debugManager.log(payload);

            this.loadPageData_OnlyOnceGuard = true;

            this.setState({
              pageData: {...payload},
            });
            this.setState({
              email: payload.email,
            });

          } else {
            // AUTH USER EXPIRED
            if (error.code == 2) {
              alert('帳號被登出，請重新登入');
              window.location.href = '/login';
              //this.props.history.push('/login')
              return;
            }

            alert(error.message);
          }
        }, async (err) => {
          // CLOSE WAITING SCREEN
          StaticEvent.LoadingEvent.next(false);
          _.debugManager.warn(err);
          alert('網路連線有問題');
        }
      );
  }

  render() {
    return (
      <>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref="/" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.props.history.goBack();
              }} text="返回"/>
            </IonButtons>
            <IonTitle>我要密碼保護登入</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent className="stmgr" color="medium" scroll-y="false">

          {this.state.pageData && <React.Fragment>

            {this.state.pageData.CanAccountLogin == true ? <React.Fragment>
              <div className="panelpage">
                <div className="itembox">
                  <h3>建立密碼</h3>
                  <p>請記住您輸入的密碼</p>
                  <IonList no-lines>
                    <IonItem>
                      <IonLabel position="floating">電子信箱 (用來找回密碼，請檢查是否正確)</IonLabel>
                      <IonInput
                        name="email"
                        onInput={(e: any) => this.handleInputChange(e)}
                        placeholder="請輸入email"
                        value={this.state.email}
                        type="text" required>
                      </IonInput>
                    </IonItem>
                    <IonItem>
                      <IonLabel position="floating">設定密碼</IonLabel>
                      <IonInput
                        name="password"
                        onInput={(e: any) => this.handleInputChange(e)}
                        placeholder="請輸入密碼"
                        value={this.state.password}
                        type="password" required>
                      </IonInput>
                    </IonItem>
                    <IonItem id="markCheck">
                      <IonLabel position="floating">確認密碼</IonLabel>
                      <IonInput
                        name="passwordagain"
                        onInput={(e: any) => this.handleInputChange(e)}
                        placeholder="請再輸入確認密碼"
                        value={this.state.passwordagain}
                        type="password" required>
                      </IonInput>
                    </IonItem>

                  </IonList>
                  <IonRow responsive-sm>
                    <IonCol>
                      <IonButton expand="block" color="primary" type="submit" onClick={(e) => this.createAccount(e)}>
                        送出
                      </IonButton>
                    </IonCol>
                  </IonRow>
                </div>
              </div>
            </React.Fragment> : <React.Fragment>
              {this.state.pageData.failReason}
            </React.Fragment>
            }


          </React.Fragment>
          }

        </IonContent>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  conferenceDate: selectors.sessions.conferenceStart(state.sessions),
});

export default connect(
  mapStateToProps
)(SetPassword);
